<!--C2-迭代需求 #42964 (小鹏P7促销活动H5)-->
<template>
  <div class="success-bg">
    <div class="success-box">
      <img src="../../assets/image/CustomersInfo/weiLai_icon.png" class="icon" />
      <div class="warning">提交成功</div>
      <div class="warning-small">车家客户经理将尽快与您联系</div>
      <div class="finish-btn" @click="goBack">完成</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$router.replace('/nio');
    },
  },
};
</script>

<style lang="less" scoped>
.flex() {
  display: -moz-box;
  /* Firefox */
  display: -ms-flexbox;
  /* IE10 */
  display: -webkit-box;
  /* Safari */
  display: -webkit-flex;
  /* Chrome, WebKit */
  display: box;
  display: flexbox;
  display: flex;
}

.success-bg {
  width: 100%;
  margin-top: 3.54rem;
  .flex();
  // align-items: center;
  justify-content: center;
  .success-box {
    .flex();
    flex-direction: column;
    align-items: center;
    .icon {
      width: 1.26rem;
      height: 1.26rem;
    }

    .warning {
      font-family: PingFangSC-Medium;
      font-size: 0.36rem;
      line-height: 0.5rem;
      color: #343333;
      text-align: center;
      margin-top: 0.2rem;
      font-weight: 500;
    }

    .warning-small {
      font-family: PingFangSC-Regular;
      font-size: 0.28rem;
      color: #666666;
      letter-spacing: 0;
      text-align: center;
      line-height: 0.44rem;
      margin-top: 0.18rem;
    }

    .finish-btn {
      width: 6rem;
      height: 0.9rem;
      cursor: pointer;
      background: #343333;
      font-family: PingFangSC-Regular;
      font-size: 0.32rem;
      line-height: 0.9rem;
      text-align: center;
      color: #ffffff;
      text-align: center;
      margin-top: 1.82rem;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WeiLai/WeiLaiSuccess.vue